import React, { useState } from 'react'
import {
  Button,
  Message
} from 'semantic-ui-react'
import {
  CirclePicker as ColorViewer,
  CompactPicker as ColorPicker
} from 'react-color'

const Swatches = ({ colors, onAddColor, onRemoveColor }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  const handleChange = (color, event) => {
    onRemoveColor && onRemoveColor(color, event)
    setDisplayColorPicker(false)
  }

  const handleAddColor = (color, event) => {
    onAddColor && onAddColor(color, event)
    setDisplayColorPicker(false)
  }

  const popover = {
    position: 'absolute',
    zIndex: '2',
  }

  const viewer = {
    position: 'relative',
    marginTop: '10px',
  }

  const handleOpenPicker = () => {
    setDisplayColorPicker(!displayColorPicker)
  }

  return (
    <>
      <Button onClick={handleOpenPicker}>Add Color</Button>
      {
        (displayColorPicker)
          ? (
            <div style={popover}>
              <ColorPicker
                onChangeComplete={handleAddColor}
              />
            </div>
          )
          : (null)
      }
      {
        (colors && colors.length > 0)
          ? (
            <div style={viewer}>
              <ColorViewer
                width={400}
                colors={colors}
                onChangeComplete={handleChange}
              />
            </div>
          )
          : (
            <div>
              <Message
                floating size='mini'
                style={ { width: '225px', marginTop: '10px' } }
              >
                You currently have no default colors.
            </Message>
            </div>
          )
      }
    </>
  )
}

export default Swatches
